import moment from "moment";

const January = 0;

type MarketType = "Ims" | "File" | "ScoringCards" | "ScoringCardsPoland";

export class DateService {
    public static componentName = "dateService";

    getDefaultBudgetYear() {
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();

        const desiredMonth = currentMonth === January ? currentYear : currentYear + 1;

        return desiredMonth;
    }

    getDefaultBudgetYearDate() {
        return new Date(this.getDefaultBudgetYear(), January, 1, 0, 0, 0, 0);
    }

    getForecastStartDate(
        configurationStartDate: Date,
        historicalDataEnd: Date,
        budgetYear: number,
        marketType: MarketType
    ) {
        switch (marketType) {
            case "Ims":
                return configurationStartDate;
            case "File":
                return new Date(new Date(historicalDataEnd).setMonth(historicalDataEnd.getMonth() + 1));
            case "ScoringCards":
            case "ScoringCardsPoland":
                return moment.utc({ year: budgetYear, month: January, hours: 0, minutes: 0 }).toDate();
            default:
                throw new Error("Trying to get forecastStartDate for not supported market type");
        }
    }

    getForecastEndDate(
        forecastStartDate: Date,
        historicalDataEnd: Date,
        defaultForecastPeriod: number,
        marketType: MarketType
    ) {
        switch (marketType) {
            case "Ims":
            case "File":
                return moment
                    .utc(forecastStartDate)
                    .endOf("year")
                    .add(defaultForecastPeriod, "years")
                    .startOf("month")
                    .toDate();
            case "ScoringCards":
            case "ScoringCardsPoland":
                return moment
                    .utc(historicalDataEnd)
                    .endOf("year")
                    .add(defaultForecastPeriod, "years")
                    .startOf("month")
                    .toDate();
            default:
                new Error("Trying to get forecastStartDate for not supported market type");
        }
    }

    getHistoricalDataStart(
        forecastStartDate: Date,
        historicalDataStart: Date | undefined,
        defaultHistoricalDataPeriod: number
    ) {
        return (
            historicalDataStart ??
            moment.utc(forecastStartDate).startOf("year").subtract(defaultHistoricalDataPeriod, "year").toDate()
        );
    }

    getHistoricalDataEnd(forecastStartDate: Date, historicalDataEnd: Date | undefined) {
        return historicalDataEnd ?? moment.utc(forecastStartDate).subtract(1, "month").toDate();
    }
}

angular.module("topline.services").service(DateService.componentName, DateService);
